<template>
  <div id="app">
    <Header></Header>
    <NavBar :navlist="navList"
            :activedNum="activedNum"></NavBar>
    <div class="containerWrap">
      <div v-for="(item,index) in (dataList?dataList.models:[])"
           :key="index">
        <component :is="item.styleType"
                   :dataList="item"></component>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/index/header.vue';
import NavBar from '@/components/index/navBar.vue';
// import quyu from '../../components/index/language.vue';//区域
import guanggao from '@/components/index/guanggao.vue';//广告
import biaoti1 from '@/components/index/biaoti1.vue';//大标题
import tuwen1 from '@/components/index/yaowen.vue';//要闻
import recommend from '@/components/index/recommend.vue';//推荐
import news_3col from '@/components/index/newsList.vue';//新闻3列
import zutu1 from '@/components/index/zutu1.vue';//高清组图
import zutu2 from '@/components/index/zutu2.vue';//文艺开讲
import youqinglink from '@/components/index/youqinglink.vue';//友情链接
import Footer from '@/components/index/footer.vue';//底部
import ajaxUtil from "@/assets/js/ajax.js";
import tools from "@/assets/js/utils.js";
export default {
  components: {
    Header,
    NavBar,
    // quyu,
    guanggao,
    biaoti1,
    tuwen1,
    recommend,
    news_3col,
    zutu1,
    zutu2,
    youqinglink,
    Footer

  },
  data () {
    return {
      navList: {},
      menuId: '',
      activedNum: '',
      modelList: [

      ],
      dataList: {},
      // dataList: {
      //   "code": 200,
      //   "msg": "ok",
      //   "data": {
      //     "models": [{
      //       "id": 2,
      //       "type": "guanggao",
      //       "sort": 2,
      //       "data": {
      //         "id": 1,
      //         "img": "http://www.people.com.cn/adv/sz770901203.jpg",
      //         "url": ""
      //       }
      //     }, {
      //       "id": 3,
      //       "type": "biaoti1",
      //       "sort": 3,
      //       "data": {
      //         "id": 1,
      //         "title": '一分一厘"背后有深情:资金投入为决胜脱贫攻坚筑牢后盾',
      //         "url": ""
      //       }
      //     }, {
      //       "id": 4,
      //       "type": "tuwen1",
      //       "sort": 4,
      //       "data": {
      //         "imgs": [
      //           { "id": 1, "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007260734190763662071912.jpg", "title": "雨中荷韵", url: "" },
      //           { "id": 2, "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007261055108863067770673.jpg", "title": "大批鴴鹬类候鸟停歇条子泥湿地高潮位栖息地", url: "" },
      //           { "id": 3, "img": "http://www.people.com.cn/NMediaFile/2020/0307/MAIN202003071050557387240854427.jpg", "title": "四川昭觉：三村新貌折射大凉山巨变", "url": "" }
      //         ],
      //         "new": {
      //           "items":
      //             [{ "id": 1, "title": "习近平同伦古、阿巴斯通电话", "url": "" },
      //             { "id": 2, "title": "一个月内三谈防汛救灾 习近平作出周密部署888888888hahas", "url": "" },
      //             { "id": 2, "title": "中央印发《中国共产党基层组织选举工作条例》", "url": "" },
      //             { "id": 2, "title": "国办:全面推进城镇老旧小区改造工作", "url": "" },
      //             { "id": 2, "title": "走向我们的小康生活:四川 绿色发展动能足", "url": "" },
      //             { "id": 2, "title": "外媒:任何企图干涉中国内政的图谋都不会得逞", "url": "" },
      //             { "id": 2, "title": "卫健委:7月20日新增确诊病例11例 本土病例8例", "url": "" },
      //             { "id": 2, "title": "美死亡病例超14万 全球地产投资因疫情下降33%", "url": "" },
      //             { "id": 2, "title": "2500万人失业金快停了 美国新刺激计划在哪？", "url": "" },
      //             { "id": 2, "title": "外媒:任何企图干涉中国内政的图谋都不会得逞", "url": "" },
      //             { "id": 2, "title": "2500万人失业金快停了 美国新刺激计划在哪？", "url": "" },
      //             { "id": 2, "title": "外媒:任何企图干涉中国内政的图谋都不会得逞", "url": "" },
      //             { "id": 2, "title": "2500万人失业金快停了 美国新刺激计划在哪？", "url": "" },
      //             { "id": 2, "title": "外媒:任何企图干涉中国内政的图谋都不会得逞", "url": "" }
      //             ]
      //         }
      //       }
      //     }, {
      //       "id": 5,
      //       "type": "recommend",
      //       "sort": 5,
      //       "data": {
      //         "title": "特别推荐",
      //         "items": [
      //           { "id": 1, "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007261056382326978538459.png", "title": "“后高考经济”升温 暑期消费应理性", "url": "", "remark": "暑期消费市场拉开序幕，“后高考”经济升温，“买买买”也需理性。" },
      //           { "id": 2, "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007260758360279454039956.jpg", "title": "他，让螃蟹在沙漠“安家”", "url": "", "remark": "引水治沙，让蟹虾在沙漠“安家”，牧民变渔民，可谓奇闻。" },
      //           { "id": 3, "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007261105344889091024742.jpg", title: "氢能迎来快速发展战略机遇期", "url": "", "remark": "随着技术日趋成熟、成本大幅下降，氢能正迎来快速发展的战略机遇期。" },
      //           { "id": 4, "img": "http://www.people.com.cn/NMediaFile/2020/0308/MAIN202003081259097365364607789.jpg", "title": "武汉最大规模方舱医院关门大吉", "url": "", "remark": "武汉市首批建成的最大规模方舱医院武汉客厅方舱医院8日正式休舱" },
      //           { "id": 5, "img": "http://www.people.com.cn/NMediaFile/2020/0308/MAIN202003081151499362102079027.jpg", "title": "这个春天,你们是披着战袍的天使", "url": "", "remark": "白衣长城,仁心围绕。身披天使战袍的她们是这个春天最美的风景线。" },
      //           { "id": 6, "img": "http://www.people.com.cn/NMediaFile/2020/0308/MAIN202003081017138593465280670.jpg", "title": "疫情下无接触零售如何谱经济新篇?", "url": "", "remark": "白衣长城,仁心围绕。身披天使战袍的她们是这个春天最美的风景线。" }
      //         ]
      //       }
      //     }, {
      //       "id": 7,
      //       "type": "news_3col",
      //       "sort": 7,
      //       "data": {
      //         "items": [{
      //           "id": 1,
      //           "title": "健康",
      //           "imgnew": {
      //             "id": 1,
      //             "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007260923566015166099348.jpg",
      //             "title": "解锁高温防暑正确“姿势”",
      //             "url": ""
      //           },
      //           "news": [{
      //             "id": 1,
      //             "title": "腰围粗寿命短 7个习惯助你塑造“小蛮腰”",
      //             "url": ""
      //           }, {
      //             "id": 2,
      //             "title": "维护各族群众生命安全和身体健康",
      //             "url": ""
      //           }, {
      //             "id": 3,
      //             "title": "三伏天应该这样 科学使用空调",
      //             "url": ""
      //           }, {
      //             "id": 4,
      //             "title": "应对洪涝灾害 记牢健康知识",
      //             "url": ""
      //           }]
      //         }, {
      //           "id": 1,
      //           "title": "旅游",
      //           "imgnew": {
      //             "id": 1,
      //             "img": "http://www.people.com.cn/NMediaFile/2020/0724/MAIN202007240856149343907282114.jpg",
      //             "title": "滨海旅游领跑海洋经济",
      //             "url": ""
      //           },
      //           "news": [{
      //             "id": 1,
      //             "title": "以优质文化产品增强文化认同",
      //             "url": ""
      //           }, {
      //             "id": 2,
      //             "title": "文旅融合 体验升级",
      //             "url": ""
      //           }, {
      //             "id": 3,
      //             "title": "旅游业：在重启中升级",
      //             "url": ""
      //           }, {
      //             "id": 4,
      //             "title": "预订量翻倍 房车旅行成跨省游黑马",
      //             "url": ""
      //           }]
      //         }, {
      //           "id": 1,
      //           "title": "教育",
      //           "imgnew": {
      //             "id": 1,
      //             "img": "http://www.people.com.cn/NMediaFile/2020/0724/MAIN202007240844203230483228230.jpg",
      //             "title": "音乐陪伴：让困境儿童获得坚强的力量",
      //             "url": ""
      //           },
      //           "news": [{
      //             "id": 1,
      //             "title": "专家支招：填报志愿可采取三种报考策略",
      //             "url": ""
      //           }, {
      //             "id": 2,
      //             "title": "以我青春力量，托举“天问”梦想",
      //             "url": ""
      //           }, {
      //             "id": 3,
      //             "title": "话网课：有无奈 亦有收获",
      //             "url": ""
      //           }, {
      //             "id": 4,
      //             "title": "教育部24365专场招聘提供岗位10万余个",
      //             "url": ""
      //           }]
      //         }]

      //       }
      //     },
      //     {
      //       "id": 2,
      //       "type": "guanggao",
      //       "sort": 2,
      //       "data": {
      //         "id": 1,
      //         "img": "http://www.people.com.cn/adv/sz770901203.jpg",
      //         "url": ""
      //       }
      //     },
      //     {
      //       "id": 7,
      //       "type": "news_3col",
      //       "sort": 7,
      //       "data": {
      //         "items": [{
      //           "id": 1,
      //           "title": "健康",
      //           "imgnew": {
      //             "id": 1,
      //             "img": "http://www.people.com.cn/NMediaFile/2020/0726/MAIN202007260923566015166099348.jpg",
      //             "title": "解锁高温防暑正确“姿势”",
      //             "url": ""
      //           },
      //           "news": [{
      //             "id": 1,
      //             "title": "腰围粗寿命短 7个习惯助你塑造“小蛮腰”",
      //             "url": ""
      //           }, {
      //             "id": 2,
      //             "title": "维护各族群众生命安全和身体健康",
      //             "url": ""
      //           }, {
      //             "id": 3,
      //             "title": "三伏天应该这样 科学使用空调",
      //             "url": ""
      //           }, {
      //             "id": 4,
      //             "title": "应对洪涝灾害 记牢健康知识",
      //             "url": ""
      //           }]
      //         }, {
      //           "id": 1,
      //           "title": "旅游",
      //           "imgnew": {
      //             "id": 1,
      //             "img": "http://www.people.com.cn/NMediaFile/2020/0724/MAIN202007240856149343907282114.jpg",
      //             "title": "滨海旅游领跑海洋经济",
      //             "url": ""
      //           },
      //           "news": [{
      //             "id": 1,
      //             "title": "以优质文化产品增强文化认同",
      //             "url": ""
      //           }, {
      //             "id": 2,
      //             "title": "文旅融合 体验升级",
      //             "url": ""
      //           }, {
      //             "id": 3,
      //             "title": "旅游业：在重启中升级",
      //             "url": ""
      //           }, {
      //             "id": 4,
      //             "title": "预订量翻倍 房车旅行成跨省游黑马",
      //             "url": ""
      //           }]
      //         }, {
      //           "id": 1,
      //           "title": "教育",
      //           "imgnew": {
      //             "id": 1,
      //             "img": "http://www.people.com.cn/NMediaFile/2020/0724/MAIN202007240844203230483228230.jpg",
      //             "title": "音乐陪伴：让困境儿童获得坚强的力量",
      //             "url": ""
      //           },
      //           "news": [{
      //             "id": 1,
      //             "title": "专家支招：填报志愿可采取三种报考策略",
      //             "url": ""
      //           }, {
      //             "id": 2,
      //             "title": "以我青春力量，托举“天问”梦想",
      //             "url": ""
      //           }, {
      //             "id": 3,
      //             "title": "话网课：有无奈 亦有收获",
      //             "url": ""
      //           }, {
      //             "id": 4,
      //             "title": "教育部24365专场招聘提供岗位10万余个",
      //             "url": ""
      //           }]
      //         }]

      //       }
      //     }, {
      //       "id": 8,
      //       "type": "zutu1",
      //       "sort": 8,
      //       "data": {
      //         "items": [
      //           { "id": 1, "img": "https://inews.gtimg.com/newsapp_ls/0/12148554684_640330/0", "title": "南非最美的城市，融合了非洲狂野与欧洲文明，是该国3个首都之一", "url": "" },
      //           { "id": 2, "img": "https://inews.gtimg.com/newsapp_ls/0/12154165222_640330/0", "title": "郭晶晶高调现身活动！一身黑白职场穿搭助阵老公，太有女强人范儿", "url": "" },
      //           { "id": 3, "img": "https://inews.gtimg.com/newsapp_ls/0/12154504899_640330/0", "title": "不给别人添麻烦！72岁奶奶垃圾场开荒，2亩花生卖万元养老", "url": "" },
      //           { "id": 1, "img": "https://inews.gtimg.com/newsapp_ls/0/12154842026_640330/0", "title": "婚宴都比不了！下水捞100只河蚌，东北一家人吃了2天", "url": "" },
      //           { "id": 2, "img": "https://inews.gtimg.com/newsapp_ls/0/12154482854_640330/0", "title": "范冰冰时隔2年走红毯，穿近两万元连衣裙背15400包，依旧女王范足", "url": "" },
      //           { "id": 3, "img": "https://inews.gtimg.com/newsapp_ls/0/12155069978_640330/0", "title": "瑞士最壮观的冰川，横卧阿尔卑斯山谷，是当地绝美的“徒步天堂”", "url": "" },

      //         ]
      //       }
      //     },
      //     {
      //       "id": 12,
      //       "type": "zutu2",
      //       "sort": 12,
      //       "data": {
      //         "items": [
      //           { "id": 1, "img": "http://culture.people.com.cn/NMediaFile/2020/0630/MAIN202006301525425420537906803.jpg", "title": "乘风破浪的秦岚，勇敢走出“舒适圈”", "url": "", "content": "对秦岚而言，最重要的是抓住每次机会释放自己，在下一部戏里实现“不一样”的转身。" },
      //           { "id": 2, "img": "http://culture.people.com.cn/NMediaFile/2020/0628/MAIN202006281013450584236991259.jpg", "title": "秦昊：“角落”终于不再“隐秘”", "url": "", "content": "坚决拒演反派人物的秦昊，是怎么被“忽悠”进组的？秦昊为何要为张东升设计假发造型？" },
      //           { "id": 3, "img": "http://culture.people.com.cn/NMediaFile/2020/0514/MAIN202005141439506823636807986.png", "title": "法与情，柔情铁汉胡军的猎与被猎", "url": "", "content": "从艺三十年来，胡军演绎了众多“英雄”“硬汉”形象。对于演戏，他始终保有一颗敬畏之心。" },
      //           { "id": 1, "img": "http://culture.people.com.cn/NMediaFile/2020/0710/MAIN202007101018427955432214893.png", "title": "潘粤明：“有情”不是“饮水饱”", "url": "", "content": "在新剧中，潘粤明饰演了一位研究大龄女青年情感问题的大学教授，看起来温文尔雅，却以“毒舌”著称。" },
      //           { "id": 2, "img": "http://culture.people.com.cn/NMediaFile/2020/0606/MAIN202006061446442203460907351.png", "title": "夏雨：鉴古见初心", "url": "", "content": "夏雨说：“‘鉴古易，鉴人难’，我很喜欢这句话。鉴人难，最难的就是鉴别自己”。" },
      //           { "id": 3, "img": "http://culture.people.com.cn/NMediaFile/2020/0511/MAIN202005111012225280544968580.jpg", "title": "“80后”王蒙：我以我笔荐轩辕", "url": "", "content": "这位忘情于文学的“高龄少年”，将以热忱之情、关爱之心，继续捕捉生活的艰难与华彩。" }

      //         ]
      //       }
      //     }, {
      //       "id": 9,
      //       "type": "youqinglink",
      //       "sort": 9,
      //       "data": {
      //         "items": [
      //           { "name": "中央网", "url": "" },
      //           { "name": "国际在线", "url": "" },
      //           { "name": "中国新闻网", "url": "" },

      //         ]
      //       }
      //     }]
      //   }
      // }
    }
  },
  created () {
    this.getMenuId();
  },
  mounted () {
    this.getMenuId();
    this.init();
    this.getModules();
  },
  methods: {
    //获取menuId
    getMenuId () {
      var menuId = tools.getUrlPara('menuId');
      if (menuId) {
        this.menuId = menuId;

      } else {
        this.menuId = "1";
      }
      this.activedNum = menuId
    },
    // 渲染导航栏
    init () {
      var that = this;
      ajaxUtil.post('/api/web/menus/v1', {

      }).then(({ data }) => {

        that.navList = data;


      }).catch((err) => {

      });
    },
    getModules () {
      var that = this;
      ajaxUtil.post('/api/web/menuData/v1', {
        menuId: this.menuId
      }).then(({ data }) => {
        this.dataList = data;

      }).catch((err) => {

      });
    }
  }
}
</script>

<style lang="less" >
#app {
  padding: 25px 0 0 0;
  .containerWrap {
    min-height: 300px;
  }
}
</style>
